import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import {
    IAtendimentoDetalhadoCobranca,
    IListaStatusCobranca,
    ListarAtendimentosRequest,
    ListarAtendimentosResponse,
} from "../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarAtendimentosService(
    requestBody: ListarAtendimentosRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    todos?: boolean
) {
    return Service(
        Axios.post<ListarAtendimentosResponse>(
            `/cobranca/atendimentos/listaratendimentos?SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&todos=${
                todos ?? false
            }`,
            requestBody
        )
    );
}

export async function ExportarExcelAtendimentosCobrancaService(
    data: ListarAtendimentosRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Service(
        Axios.post<Blob>(
            `/cobranca/atendimentos/listaratendimentosexportarexcel?SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}`,
            data,
            { responseType: "blob" }
        )
    );
}

export async function GetAtendimentoService(ID_CASO: number) {
    return Service(
        Axios.get<IAtendimentoDetalhadoCobranca>(
            `/cobranca/atendimentos/getatendimento?ID_CASO=${ID_CASO}`
        )
    );
}

export async function BuscaStatusCobrancaService() {
    return Service(
        Axios.get<Array<IListaStatusCobranca>>(
            `/cobranca/atendimentos/buscastatuscobranca`
        )
    );
}

export async function AtualizarStatusCobrancaService(
    ID_CHAVE_ERP: string,
    requestBody: [{ codigo: number }]
) {
    return Service(
        Axios.post(
            `/cobranca/atendimentos/atualizastatuscobranca?ID_CHAVE_ERP=${ID_CHAVE_ERP}`,
            requestBody
        )
    );
}
